import React from "react";
import {
  Button,
  Box,
} from "@mui/material"; // Update to MUI v5 imports
import { StyledButton } from "../styled-button/styled-button";
import { useTranslation } from "react-i18next";

type IProps = {
  stepsContent: { [index: string]: React.ReactElement | string };
  steps: string[];
  icons: { [index: string]: React.ReactElement };
  handleCancel: () => void;
  handleDone: () => void;
  isValid: boolean;
  isSameValue?: boolean;
  isEdit: boolean;
};

const StepperComponent = (props: IProps) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const { t } = useTranslation();
  const { steps, stepsContent, handleCancel, handleDone } = props;

  const handleNextClick = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleDoneClick = () => {
    handleDone();
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCancelClick = () => {
    setActiveStep(0);
    handleCancel();
  };

  const getStepContent = (stepIndex: number) => {
    return stepsContent[stepIndex] || "Unknown stepIndex";
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        {getStepContent(activeStep)}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>

          <StyledButton variant="contained" onClick={handleCancelClick}>
            {t("common_cancel")}
          </StyledButton>
          <StyledButton
            data-testid="done-button" 
            id="done-button"
            disabled={!props.isValid}// || (props.isValid && props.isSameValue)}
            variant="contained"
            color="primary"
            onClick={handleDoneClick}
          >
            {props.isEdit ? t("common_save") : t("common_add")}
          </StyledButton>
        </Box>
      </Box>
    </>
  );
};

export default StepperComponent;
